import styled, { keyframes } from 'styled-components'

import { color, radius, spacing } from '../../../themes'

export const Container = styled.div<{ autoWidth?: boolean }>`
  width: ${({ autoWidth }) => (autoWidth ? 'auto' : '100%')};
  position: relative;
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

interface PopupProps {
  open: boolean
}

export const Popup = styled.ul<PopupProps>`
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.1),
    0px 0px 0px 1px rgba(0, 0, 0, 0.02);
  opacity: ${({ open }) => (open ? 1 : 0)};
  animation: ${({ open }) => (open ? fadeIn : fadeOut)} 0.1s ease-in-out;
  border-radius: ${radius('md')};
  padding: ${spacing(2, 0)};
  max-height: 348px;
  overflow-y: auto;
  z-index: 10;
  background: ${color('white')};
  outline: 0;
  user-select: none;
  box-sizing: border-box;
`
